import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  icon: css`
    font-size: 36px;
    display: block;
    padding-right: ${theme.spacing(1)}px;
    box-sizing: content-box;
  `,
  title: css`
    font-size: 18px;
    font-weight: bold;
  `,
  divider: css`
    margin-bottom: 0;
  `,
}
